
__webpack_require__.debugRequireIds = {
	"-!./debug-require.cjs": 2800,
	"-!jquery": 49949,
	"./debug-require.cjs": 13732,
	"./src/base_page_params.ts": 19478,
	"./src/blueslip.ts": 21284,
	"./src/blueslip_stacktrace.ts": 22914,
	"./src/bot_types.ts": 3639,
	"./src/bundles/common.ts": 12881,
	"./src/bundles/marketing_page_bundle.ts": 99257,
	"./src/csrf.ts": 51648,
	"./src/portico/google-analytics.ts": 22921,
	"./src/portico/header.ts": 56190,
	"./src/realm_user_settings_defaults.ts": 67058,
	"./src/sentry.ts": 60281,
	"./src/state_data.ts": 39460,
	"./src/stream_types.ts": 86952,
	"./src/types.ts": 73037,
	"./src/user_settings.ts": 16053,
	"./src/user_status_types.ts": 51612,
	"./styles/portico/marketing_page.css": 7427,
	"./styles/portico/portico_variables.css": 13983,
	"./styles/portico/pricing_plans.css": 15778,
	"./templates/blueslip_stacktrace.hbs": 24075,
	"./templates/team/contributor_count.hbs": 63684,
	"./templates/team/contributors.hbs": 26605,
	"./templates/team/loading.hbs": 82923,
	"./templates/team/total_contributor_count.hbs": 16751,
	"@formatjs/fast-memoize": 45944,
	"core-js/modules/es.array-buffer.detached.js": 39270,
	"core-js/modules/es.array-buffer.transfer-to-fixed-length.js": 51671,
	"core-js/modules/es.array-buffer.transfer.js": 16103,
	"core-js/modules/es.array.push.js": 64755,
	"core-js/modules/es.array.to-sorted.js": 84162,
	"core-js/modules/es.iterator.constructor.js": 94178,
	"core-js/modules/es.iterator.filter.js": 79342,
	"core-js/modules/es.iterator.find.js": 58471,
	"core-js/modules/es.iterator.flat-map.js": 40392,
	"core-js/modules/es.iterator.map.js": 64792,
	"core-js/modules/es.iterator.reduce.js": 85382,
	"core-js/modules/es.iterator.some.js": 3380,
	"core-js/modules/es.json.stringify.js": 99811,
	"core-js/modules/es.set.difference.v2.js": 23029,
	"core-js/modules/es.set.intersection.v2.js": 22659,
	"core-js/modules/es.set.is-disjoint-from.v2.js": 54726,
	"core-js/modules/es.set.is-subset-of.v2.js": 9491,
	"core-js/modules/es.set.is-superset-of.v2.js": 57748,
	"core-js/modules/es.set.symmetric-difference.v2.js": 2715,
	"core-js/modules/es.set.union.v2.js": 69351,
	"core-js/modules/es.typed-array.to-reversed.js": 91136,
	"core-js/modules/es.typed-array.to-sorted.js": 49639,
	"core-js/modules/es.typed-array.with.js": 72260,
	"core-js/modules/esnext.json.parse.js": 22862,
	"core-js/modules/esnext.uint8-array.set-from-base64.js": 9386,
	"core-js/modules/esnext.uint8-array.set-from-hex.js": 61868,
	"core-js/modules/esnext.uint8-array.to-base64.js": 10460,
	"core-js/modules/esnext.uint8-array.to-hex.js": 90718,
	"core-js/modules/web.url-search-params.delete.js": 89584,
	"core-js/modules/web.url-search-params.has.js": 17535,
	"core-js/modules/web.url-search-params.size.js": 10418,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 81942,
	"jquery": 93576,
	"lodash": 25043,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"tslib": 56636,
	"zod/mini": 25103
};